import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchApprovalStatusList = createAsyncThunk("fetchApprovalStatusList", async () => {
	try {
		const response = await axiosHttp.get(`approvals/status`);
		return response.data.data;
	} catch (error) {
		console.error("API Error:", error);
		throw error;
	}
});

const ApprovalStatusListSlice = createSlice({
	name: "ApprovalStatusListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchApprovalStatusList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchApprovalStatusList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchApprovalStatusList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default ApprovalStatusListSlice.reducer;
